import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CookieService, PaymentV2Service, UtilService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-payment-sip-upi-intents',
  templateUrl: './payment-sip-upi-intents.component.html',
  styleUrls: ['./payment-sip-upi-intents.component.scss']
})
export class PaymentSipUpiIntentsComponent implements OnInit, OnDestroy {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  subs: Subscription[] = [];

  constructor(
    private util: UtilService,
    private paymentV2: PaymentV2Service,
    private cookieService: CookieService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
  }

  submit(upi) {
    if (this.util.getMobileOperatingSystem() === 'iOS') {
      return false;
    }
    // Version check if app > 1.0.3 on android
    if (this.cookieService.getCookie('platform') === 'android' && (!this.cookieService.getCookie('app_version') || this.checkVersion(this.cookieService.getCookie('app_version')))) {
      return false;
    }

    if (this.util.isMobile() && !this.paymentV2.isOrderLoading && upi.value.intent) {
      const emitPayload = {
        mode: this.config.selectedTab.order_mode,
        mode_value: upi.key,
      }
      if (this.config.sip_wallet !== 1) {
        this.checkPaymentStatus();
      }
      this.dataEmit.emit(emitPayload);
    }
  }

  checkPaymentStatus() {
    this.subs.push(
      this.util.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.cancelPayment();
          this.util.router.navigate(['/new/payment-route'], { queryParams: this.util.vars.tyParams });
        } else if (val === 'failed') {
          this.cancelPayment();
        }
      })
    );
  }

  cancelPayment() {
    this.util.vars.upi_payment_status.next('canceled');
  }


  checkVersion(appVersion) {
    if (appVersion) {
      return appVersion.localeCompare('1.0.3', undefined, { numeric: true, sensitivity: 'base' }) === 1 ? false : true;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}
